// Environment variables for React web application
const orderCollection = process.env.REACT_APP_ORDERS_COLLECTION;
const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY;
const firebaseAuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const firebaseProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const firebaseStorageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const firebaseMessagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const firebaseAppId = process.env.REACT_APP_FIREBASE_APP_ID;
const firebaseMeasurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const logRocketAppId = process.env.REACT_APP_LOGROCKET_APP_ID;
const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const FIREBASE_CONFIG = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
  measurementId: firebaseMeasurementId
}

export const API_CONFIG = {
  baseUrl: apiBaseUrl,
  logRocketAppId: logRocketAppId,
  googleMapsApiKey: googleMapsApiKey
}
export const ORDER_COLLECTION = orderCollection